import { TableExtractPtBr } from "./table-extract-pt-br";

export const TABLE_EXTRACT_ES_MX: TableExtractPtBr = {
	consolidated: {
		title: "Periodo Consolidado",
		totalTitle: "Total de periodo de {{period}}",
		tooltip: "¿Qué es el resumen de competencia?",
		tooltipDescription:
			"Operaciones agrupadas por la fecha en que la operación o evento económico realmente ocurrió.",
	},
	cashFlow: {
		title: "Transacciones del período",
		totalTitle: "Saldo Final Liquidado del período",
		tooltip: "¿Qué es el resumen de transacciones?",
		tooltipDescription:
			"Operaciones de transacciones realizadas durante el período seleccionado.",
	},
	tpv: {
		title: "Cuentas por Cobrar del Período",
		totalTitle: "Total del Período",
		tooltip: "¿Qué son las Cuentas por Cobrar del Período?",
		tooltipDescription:
			"Valor bruto de los TPVs agrupados del período consultado, representando los valores a recibir de las transacciones procesadas.",
	},
	total: "Total",
	name: "Descripción",
	value: "Valor",
	grossValue: "Valor Bruto",
	netValue: "Valor Neto",
	tax: "Impuesto",
	base: "Base",
	feePercentage: "Tarifa",
	from: "De",
	to: "a",
	group: "Agrupación",
	excel: {
		title:
			"Informe Consolidado por Período de Transacciones y Consolidado de Competencia  {{startDate}} a {{endDate}}",
		fileName: "informe_consolidado_transacciones_{{startDate}}_a_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Transacciones del período",
	competenceConsolidated: "Consolidado de Competencia",
	notLiquidatedTransactions: "Transacciones no liquidadas del período",
	anticipatedValue: "Valor Anticipado",
	obs: "Observación",
	seeTransactions: "Ver Transacciones",
	dateType: {
		competence: "Fecha de Competencia",
		liquidation: "Fecha de Liquidación",
	},
	dateTypeLabel: "Filtrar por",
	competence: "Competencia",
	liquidation: "Liquidación",
	apply: "Aplicar",
	totalEntries: "Total de Entradas",
	totalExits: "Total de Salidas",
	initialBalance: "Saldo Inicial",
};
